import React from 'react';

const Svg = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M1 12.0857V15.0025H3.91678L12.5193 6.39993L9.60256 3.48315L1 12.0857ZM14.775 4.14429C15.0784 3.84095 15.0784 3.35093 14.775 3.04758L12.955 1.22751C12.6516 0.924164 12.1616 0.924164 11.8582 1.22751L10.4349 2.6509L13.3516 5.56768L14.775 4.14429Z" fill="#B8238E" />
  </svg>
);

export default Svg;
